import { render, staticRenderFns } from "./NoBasic.vue?vue&type=template&id=61d96a2a&scoped=true"
import script from "./NoBasic.vue?vue&type=script&lang=ts"
export * from "./NoBasic.vue?vue&type=script&lang=ts"
import style0 from "./NoBasic.vue?vue&type=style&index=0&id=61d96a2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d96a2a",
  null
  
)

export default component.exports